import React from 'react'

const ResidentVisitors = () => {
  return (
    <div>ResidentVisitors</div>
  )
}

export default ResidentVisitors